import React from "react";
import { Modal, ModalBody, Button, Progress } from "reactstrap";
import api from "./../../../Api.js";
import PixelCharacterFigure from "./../gamification/PixelCharacterFigure.jsx";

/**
 * EnemyChallenge — modal de combate com inimigo/boss.
 * Aluno responde pergunta, certo = dano no inimigo, errado = leva dano.
 */
class EnemyChallenge extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      enemy: props.enemy,
      answered: false,
      lastResult: null,
      shaking: false,
      heroAnim: 'idle',   // slash quando acerta, hurt quando leva contra-ataque
      enemyAnim: 'idle'   // hurt quando toma dano
    };
  }

  /**
   * Cenario da arena — muda conforme o inimigo: campo de dia pros comuns,
   * entardecer pros elite e noite sombria pro boss.
   */
  cenario(tipo) {
    if (tipo === 'boss') {
      return {
        ceu: 'linear-gradient(180deg, #0f0c29 0%, #302b63 45%, #24243e 62%)',
        chao: 'linear-gradient(180deg, #3d2b4f 0%, #1a1024 100%)',
        astro: { background: 'radial-gradient(circle, #fff3cd 0%, #f6d365 70%)', boxShadow: '0 0 24px rgba(246,211,101,0.7)' },
        morro: '#241633',
        estrelas: true
      };
    }
    if (tipo === 'elite') {
      return {
        ceu: 'linear-gradient(180deg, #ff9a44 0%, #fc6076 45%, #c95a5a 62%)',
        chao: 'linear-gradient(180deg, #8d6e63 0%, #5d4037 100%)',
        astro: { background: 'radial-gradient(circle, #fff7e6 0%, #ffb347 70%)', boxShadow: '0 0 22px rgba(255,179,71,0.75)' },
        morro: '#7a4a3a',
        estrelas: false
      };
    }
    return {
      ceu: 'linear-gradient(180deg, #7ec8f2 0%, #bfe6f7 45%, #cfeeff 62%)',
      chao: 'linear-gradient(180deg, #7cb342 0%, #4e7a26 100%)',
      astro: { background: 'radial-gradient(circle, #fffde7 0%, #ffe082 70%)', boxShadow: '0 0 20px rgba(255,224,130,0.8)' },
      morro: '#5d9e3a',
      estrelas: false
    };
  }

  //camadas do sprite do inimigo (backend manda em `layers` ou no spritePath)
  enemyLayers() {
    var e = this.state.enemy || {};
    if (Array.isArray(e.layers) && e.layers.length) return e.layers;
    if (typeof e.spritePath === 'string' && e.spritePath.charAt(0) === '[') {
      try { return JSON.parse(e.spritePath); } catch (err) { return null; }
    }
    return null;
  }

  async submit(answerIndex) {
    if (this.state.answered) return;
    this.setState({ answered: true });
    try {
      var res = await api.answerEnemy(this.state.enemy.id, answerIndex);
      var result = res.data;

      this.setState({
        lastResult: result,
        shaking: !result.correct && !result.secondChance,
        // acertou: heroi ataca · errou: apanha (ou pula, se esquivou/corrigiu a mira)
        heroAnim: result.correct ? 'slash' : ((result.dodged || result.secondChance) ? 'jump' : 'hurt'),
        enemyAnim: result.correct ? 'hurt' : 'slash',
        enemy: Object.assign({}, this.state.enemy, {
          currentHp: result.enemyHpAfter !== undefined ? result.enemyHpAfter : this.state.enemy.currentHp,
          status: result.defeated ? 'defeated' : 'alive',
          question: result.nextQuestion || this.state.enemy.question
        })
      });

      // Se derrotou, fecha em 3s
      if (result.defeated) {
        setTimeout(() => {
          if (this.props.onDefeated) this.props.onDefeated(result);
        }, 3000);
      } else {
        // Habilita proxima resposta após 1.5s
        setTimeout(() => {
          this.setState({ answered: false, lastResult: null, shaking: false, heroAnim: 'idle', enemyAnim: 'idle' });
        }, 1500);
      }
    } catch (e) {
      this.setState({ answered: false });
    }
  }

  render() {
    var enemy = this.state.enemy;
    var question = enemy.question;
    var hpPct = enemy.maxHp ? (enemy.currentHp / enemy.maxHp) * 100 : 100;
    var lastResult = this.state.lastResult;

    var enemyColor = enemy.type === 'boss' ? '#9C27B0' : enemy.type === 'elite' ? '#FF9800' : '#dc3545';
    var enemyIcon = enemy.type === 'boss' ? 'fa-dragon' : enemy.type === 'elite' ? 'fa-skull' : 'fa-spider';
    var enemyLayers = this.enemyLayers();
    var cena = this.cenario(enemy.type);

    return (
      <Modal isOpen={true} backdrop="static" centered size="lg">
        <ModalBody style={{ padding: 0, overflow: 'hidden' }}>
          {/* Header com inimigo */}
          <div style={{
            background: 'linear-gradient(135deg, ' + enemyColor + ' 0%, ' + enemyColor + 'aa 100%)',
            padding: '20px',
            color: '#fff',
            textAlign: 'center',
            animation: this.state.shaking ? 'shake 0.5s' : 'none'
          }}>
            {/* Arena com cenario: heroi de um lado, monstro do outro */}
            <div style={{
              position: 'relative',
              height: '150px',
              borderRadius: '10px',
              overflow: 'hidden',
              marginBottom: '12px',
              boxShadow: 'inset 0 2px 14px rgba(0,0,0,0.35)',
              background: cena.ceu
            }}>
              {/* sol / lua */}
              <div style={{
                position: 'absolute', top: '14px', right: '26px',
                width: '26px', height: '26px', borderRadius: '50%',
                ...cena.astro
              }} />

              {/* estrelas (so a noite do boss) */}
              {cena.estrelas && [12, 34, 58, 76, 92, 120, 150, 175, 205, 240].map((x, i) => (
                <div key={'st' + i} style={{
                  position: 'absolute',
                  left: x + 'px', top: (8 + (i % 4) * 11) + 'px',
                  width: '2px', height: '2px', borderRadius: '50%',
                  background: '#fff', opacity: 0.55 + (i % 3) * 0.15
                }} />
              ))}

              {/* morros ao fundo */}
              <div style={{
                position: 'absolute', bottom: '38%', left: '-8%',
                width: '55%', height: '42px', borderRadius: '50% 50% 0 0',
                background: cena.morro, opacity: 0.85
              }} />
              <div style={{
                position: 'absolute', bottom: '38%', right: '-6%',
                width: '48%', height: '34px', borderRadius: '50% 50% 0 0',
                background: cena.morro, opacity: 0.7
              }} />

              {/* chao */}
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                height: '38%', background: cena.chao,
                borderTop: '2px solid rgba(0,0,0,0.18)'
              }} />

              {/* combatentes sobre o cenario */}
              <div className="d-flex align-items-end justify-content-center" style={{
                position: 'absolute', bottom: '10px', left: 0, right: 0, gap: '10px'
              }}>
              {this.props.heroEquipped && this.props.heroEquipped.length > 0 && (
                <div style={{ textAlign: 'center' }}>
                  <PixelCharacterFigure
                    equipped={this.props.heroEquipped}
                    scale={2}
                    direction={192}
                    animation={this.state.heroAnim}
                    hideScenery
                    background="transparent"
                  />
                  <div style={{ fontSize: '0.65rem', opacity: 0.85, marginTop: '2px' }}>VOCÊ</div>
                </div>
              )}

              <div style={{ fontSize: '1.4rem', alignSelf: 'center', opacity: 0.9 }}>⚔️</div>

              {enemyLayers ? (
                <div style={{ textAlign: 'center' }}>
                  <PixelCharacterFigure
                    equipped={enemyLayers}
                    scale={2}
                    direction={64}
                    animation={this.state.enemyAnim}
                    hideScenery
                    background="transparent"
                  />
                  <div style={{ fontSize: '0.65rem', opacity: 0.85, marginTop: '2px' }}>INIMIGO</div>
                </div>
              ) : (
                <i className={'fas ' + enemyIcon + ' fa-4x'} style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))' }} />
              )}
              </div>
            </div>

            <h2 style={{ margin: 0, fontWeight: 700 }}>
              {enemy.type === 'boss' ? '🐲 ' : enemy.type === 'elite' ? '⚔️ ' : ''}{enemy.name}
            </h2>
            <small style={{ opacity: 0.9, textTransform: 'uppercase', letterSpacing: '2px' }}>
              {enemy.type === 'boss' ? 'BOSS BATTLE' : enemy.type === 'elite' ? 'ELITE' : 'INIMIGO'}
            </small>

            {/* HP do inimigo */}
            <div className="mt-3" style={{ background: 'rgba(0,0,0,0.3)', borderRadius: '20px', padding: '8px 16px' }}>
              <div className="d-flex justify-content-between mb-1">
                <small><i className="fas fa-heart" /> HP do Inimigo</small>
                <small>{enemy.currentHp}/{enemy.maxHp}</small>
              </div>
              <Progress
                value={hpPct}
                style={{ height: '10px', backgroundColor: 'rgba(255,255,255,0.2)' }}
                barStyle={{ background: '#fff', transition: 'width 0.5s' }}
              />
            </div>

            {/* Recompensa */}
            <div className="mt-2">
              <small>
                Recompensa: <strong>+{enemy.xpReward} XP</strong> · <strong>+{enemy.goldReward} 🪙</strong>
              </small>
            </div>
          </div>

          {/* Body com pergunta */}
          <div style={{ padding: '25px' }}>
            {lastResult && lastResult.correct && (
              <div className="alert alert-success text-center mb-3">
                <i className="fas fa-bolt fa-2x mb-1" />
                <h5 className="mb-0">Acertou! Causou {lastResult.damage} de dano!</h5>
              </div>
            )}
            {lastResult && !lastResult.correct && lastResult.secondChance && (
              <div className="alert alert-info text-center mb-3">
                <i className="fas fa-bullseye fa-2x mb-1" />
                <h5 className="mb-0">🏹 Tiro Certeiro!</h5>
                <small className="d-block mt-1">{lastResult.message || 'O erro não contou — tente de novo!'}</small>
              </div>
            )}
            {lastResult && !lastResult.correct && !lastResult.secondChance && (
              <div className="alert alert-danger text-center mb-3">
                <i className={'fa-2x mb-1 fas ' + (lastResult.dodged ? 'fa-wind' : 'fa-times-circle')} />
                <h5 className="mb-0">
                  {lastResult.dodged
                    ? '🥷 Errou, mas esquivou do ataque!'
                    : 'Errou! Você levou ' + lastResult.damage + ' de dano'}
                </h5>
                {lastResult.explanation && <small className="d-block mt-1">{lastResult.explanation}</small>}
              </div>
            )}
            {lastResult && lastResult.defeated && (
              <div className="alert alert-warning text-center mb-3">
                <i className="fas fa-trophy fa-3x mb-2" style={{ color: '#FFD700' }} />
                <h3>VITÓRIA!</h3>
                {lastResult.rewards && (
                  <p className="mb-0">
                    +{lastResult.rewards.xp} XP · +{lastResult.rewards.gold} Gold
                  </p>
                )}
                {lastResult.rewards && lastResult.rewards.treasure && (
                  <div className="mt-2" style={{
                    background: 'linear-gradient(135deg, #FFD700 0%, #FFA000 100%)',
                    color: '#fff', borderRadius: '8px', padding: '6px 10px',
                    fontWeight: 700, textShadow: '0 1px 2px rgba(0,0,0,0.25)'
                  }}>
                    🎁 TESOURO! +{lastResult.rewards.treasure.gold} 🪙 · +{lastResult.rewards.treasure.xp} XP
                  </div>
                )}
              </div>
            )}

            {!lastResult && question && (
              <React.Fragment>
                <h4 className="mb-4 text-center" style={{
                  background: '#f8f9fa',
                  padding: '20px',
                  borderRadius: '8px',
                  borderLeft: '4px solid ' + enemyColor
                }}>
                  ⚔️ {question.question}
                </h4>
                {question.options && question.options.map((opt, idx) => (
                  <Button
                    key={idx}
                    color="primary"
                    block
                    size="lg"
                    className="mb-2 text-left"
                    onClick={() => this.submit(idx)}
                    disabled={this.state.answered}
                    style={{ padding: '15px 20px' }}
                  >
                    <strong>{String.fromCharCode(65 + idx)})</strong> {opt}
                  </Button>
                ))}
              </React.Fragment>
            )}
          </div>

          <style>{`
            @keyframes shake {
              0%, 100% { transform: translateX(0); }
              25% { transform: translateX(-10px); }
              75% { transform: translateX(10px); }
            }
          `}</style>
        </ModalBody>
      </Modal>
    );
  }
}

export default EnemyChallenge;
